"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggledIconSlide = exports.ToggleSlide = exports.ToggleBtnContainer = exports.StyledIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _check = _interopRequireDefault(require("./assets/check.svg"));

var _cross = _interopRequireDefault(require("./assets/cross.svg"));

var _activeHorizontalToggleIcon = _interopRequireDefault(require("./assets/active-horizontal-toggle-icon.svg"));

var _activeVerticalToggleIcon = _interopRequireDefault(require("./assets/active-vertical-toggle-icon.svg"));

var _inactiveHorizontalToggleIcon = _interopRequireDefault(require("./assets/inactive-horizontal-toggle-icon.svg"));

var _inactiveVerticalToggleIcon = _interopRequireDefault(require("./assets/inactive-vertical-toggle-icon.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var icons = {
  horizontal: {
    active: _activeHorizontalToggleIcon["default"],
    inactive: _inactiveHorizontalToggleIcon["default"]
  },
  vertical: {
    active: _activeVerticalToggleIcon["default"],
    inactive: _inactiveVerticalToggleIcon["default"]
  },
  check: {
    active: _check["default"],
    inactive: _cross["default"]
  }
};

var StyledIcon = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 11px;\n  width: ", ";\n  height: ", ";\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  z-index: 3;\n"])), function (_ref) {
  var width = _ref.width;
  return width || "8px";
}, function (_ref2) {
  var height = _ref2.height;
  return height || "8px";
});

exports.StyledIcon = StyledIcon;

var ToggleBtnContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  border-radius: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-block;\n  vertical-align: text-bottom;\n\n  ", ";\n\n  ", ";\n"])), function (_ref3) {
  var widthOfMainContainer = _ref3.widthOfMainContainer;
  return widthOfMainContainer ? widthOfMainContainer : "50px";
}, function (_ref4) {
  var heightOfMainContainer = _ref4.heightOfMainContainer;
  return heightOfMainContainer ? heightOfMainContainer : "25px";
}, function (_ref5) {
  var backgroundColorForUntoggledState = _ref5.backgroundColorForUntoggledState;
  return backgroundColorForUntoggledState ? backgroundColorForUntoggledState : "#F3F4F5";
}, function (_ref6) {
  var toggled = _ref6.toggled;
  return toggled && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (_ref7) {
    var backgroundColorForToggledState = _ref7.backgroundColorForToggledState,
        theme = _ref7.theme;
    return backgroundColorForToggledState ? backgroundColorForToggledState : theme.colors.palette[7];
  });
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      pointer-events: none !important;\n      cursor: not-allowed;\n    "])));
});

exports.ToggleBtnContainer = ToggleBtnContainer;

var ToggleSlide = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: ", ";\n  height: ", ";\n  top: 2px;\n  right: 51%;\n  border-radius: 100%;\n  background-color: ", ";\n  transition: all 0.3s ease;\n  background-image: url(\"", "\");\n  background-size: 10px;\n  background-repeat: no-repeat;\n  background-position: center;\n\n  ", ";\n\n  ", ";\n"])), function (_ref9) {
  var widthOfIconContainer = _ref9.widthOfIconContainer;
  return widthOfIconContainer ? widthOfIconContainer : "21px";
}, function (_ref10) {
  var heightOfIconContainer = _ref10.heightOfIconContainer;
  return heightOfIconContainer ? heightOfIconContainer : "21px";
}, function (_ref11) {
  var backgroundColorForButtonInUnToggledState = _ref11.backgroundColorForButtonInUnToggledState;
  return backgroundColorForButtonInUnToggledState ? backgroundColorForButtonInUnToggledState : "white";
}, _cross["default"], function (_ref12) {
  var toggled = _ref12.toggled;
  return toggled && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      right: 2px;\n      background-color: ", ";\n      background-image: url(\"", "\");\n    "])), function (_ref13) {
    var backgroundColorForButtonInToggledState = _ref13.backgroundColorForButtonInToggledState;
    return backgroundColorForButtonInToggledState ? backgroundColorForButtonInToggledState : "white";
  }, _check["default"]);
}, function (_ref14) {
  var disabled = _ref14.disabled;
  return disabled && (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      background-color: white;\n    "])));
});

exports.ToggleSlide = ToggleSlide;

var ToggledIconSlide = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  top: 2px;\n  border-radius: 100%;\n  background-color: ", ";\n\n  ", "\n\n  ", ";\n"])), function (_ref15) {
  var widthOfIconContainer = _ref15.widthOfIconContainer;
  return widthOfIconContainer ? widthOfIconContainer : "21px";
}, function (_ref16) {
  var heightOfIconContainer = _ref16.heightOfIconContainer;
  return heightOfIconContainer ? heightOfIconContainer : "21px";
}, function (_ref17) {
  var backgroundColorForButtonInUnToggledState = _ref17.backgroundColorForButtonInUnToggledState;
  return backgroundColorForButtonInUnToggledState ? backgroundColorForButtonInUnToggledState : "black";
}, function (_ref18) {
  var toggled = _ref18.toggled,
      iconType = _ref18.iconType;
  return (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      background-image: url(\"", "\");\n      background-size: 20px;\n      background-repeat: no-repeat;\n      background-position: center;\n    "])), toggled ? icons[iconType].active : icons[iconType].inactive);
}, function (_ref19) {
  var disabled = _ref19.disabled;
  return disabled && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      background-color: white;\n    "])));
});

exports.ToggledIconSlide = ToggledIconSlide;

//# sourceMappingURL=styled.js.map